import React, { useState, useEffect } from "react";
import { Button, Box, Typography, Grid } from "@mui/material";
import Header1 from "../Header/Header1";
import axios from "axios";
import MyPosts from "./MyPosts";
import MyBookings from "../Platform/MyBookings";
import RequestUsersList from "../Requests/RequestUsersList";
import RequestToUsers from "../Requests/RequestToUsers";
import RequestFromUsers from "../Requests/RequestFromUsers";

const API_URL = process.env.REACT_APP_API_URL;

function MyPostsPlatform({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [activePage, setActivePage] = useState("my-posts"); // Default active page
  const [searchResults, setSearchResults] = useState([]);
  const [isVerified, setIsVerified] = useState(false);

  const handleSearch = (result) => {
    setSearchResults(result);
  };


  const checkUserVerification = async () => {
    try {
      const response = await axios.get(`${API_URL}/get_verify_user/`, { params: { user_id: userId } });
      if (response.data.status === 'verified') {
        setIsVerified(true);
      } else {
        setIsVerified(false);
      }
    } catch (error) {
      console.error('Error verifying user:', error);
      setIsVerified(false);  // Default to not verified in case of an error
    }
  };

  useEffect(() => {
    checkUserVerification();
  }, [userId]);

  const renderContent = () => {
    switch (activePage) {

      case "my-posts":
        return <MyPosts userId={userId} searchResults={searchResults} onLogout={onLogout} />;
      case "my-bookings":
        return <MyBookings userId={userId} searchResults={searchResults} onLogout={onLogout} />;
      default:
        return <Typography variant="h4" color="#ecf0f1">Welcome</Typography>;
    }
  };

  return (
    <div>
      {/* Navigation Bar */}
      <Header1 page_name={activePage} onSearch={handleSearch} />

      {/* Replaced AppBar with Box for Navbar */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },  // Switch flexDirection to column for small screens, row for larger screens
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'black',
          padding: { xs: '0.5rem', sm: '1rem' },  // Smaller padding for small screens, larger padding for larger screens
          width: '100%',
          //   mt: { xs: 10, sm: 10 },  // Adjust margin-top based on screen size (smaller on small screens)
        }}
      >
        <Grid container spacing={2} justifyContent="center" sx={{ flexDirection: { xs: 'column', sm: 'row' }, textAlign: 'center' }}>


          <Grid item>
            <Button
              onClick={() => setActivePage("my-posts")}
              sx={{
                color: activePage === "my-posts" ? "#1E90FF" : "#ecf0f1",
                textTransform: "none",
                fontSize: { xs: '0.9rem', sm: '1rem' },
                width: { xs: '100%', sm: 'auto' },
                letterSpacing: 2,
                "&:hover": {
                  backgroundColor: "#1111",
                },
                padding: { xs: '0.5rem', sm: '1rem' },
              }}
            >
              My Hosted Sessions
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => setActivePage("my-bookings")}
              sx={{
                color: activePage === "my-bookings" ? "#1E90FF" : "#ecf0f1",
                textTransform: "none",
                fontSize: { xs: '0.9rem', sm: '1rem' },
                width: { xs: '100%', sm: 'auto' },
                letterSpacing: 2,
                "&:hover": {
                  backgroundColor: "#1111",
                },
                padding: { xs: '0.5rem', sm: '1rem' },
              }}
            >
              My Booked Sessions
            </Button>
          </Grid>

        </Grid>

      </Box>

      {/* Dynamic Content */}
      <Box
        sx={{
          padding: { xs: "1rem", sm: "2rem" }, // Adjust padding for smaller and larger screens
          backgroundColor: "black",
          color: "white",
          minHeight: "calc(100vh - 64px)", // Keeps the height full minus any fixed header
          display: "flex",
          flexDirection: "column", // Ensure content is stacked vertically on small screens
          justifyContent: "center", // Centers content vertically
          alignItems: "center", // Centers content horizontally
          overflow: "hidden", // Prevents overflow on smaller screens
        }}
      >
        {renderContent()}
      </Box>

    </div>
  );
}

export default MyPostsPlatform;
